/** @file groundOf: this frame's ground marks (facing chevron, shadow) from the drawn puppet; null hides them. */
import type { GroundInput } from './groundMarks';
import { poseNode } from './poseNode';
import type { ViewportCtx } from './viewportCtx';

/** The shadow is never smaller than this half extent (units), so a thin puppet still casts one. */
const MIN_HALF = 0.25;

/**
 * Null while the grid is off or nothing is drawn; otherwise the body facing as the runtime drew it, the root node's
 * ground point (the first pose node without a parent; the shadow follows a jump or a lunge) and half the puppet's
 * `bounds` x / y.
 */
export function groundOf(ctx: ViewportCtx): GroundInput | null {
  const p = ctx.puppet();
  if (p === null || !ctx.store.getState().camera.grid) return null;
  const state = p.instance.state();
  const index = p.names.findIndex((_, i) => poseNode(state.pose, i).parent < 0);
  const root = index < 0 ? [0, 0, 0] : poseNode(state.pose, index).pos;
  const [w, d] = p.source.puppet.bounds;
  return { facingDeg: state.facingDeg, at: [root[0], root[1]], half: [Math.max(MIN_HALF, w / 2), Math.max(MIN_HALF, d / 2)] };
}
